
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/core-exchange/docs/production-access",
      function () {
        return require("private-next-pages/core-exchange/docs/production-access/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/core-exchange/docs/production-access"])
      });
    }
  